import { createContext, useState } from 'react';
import { apiV1 } from '../lib/axios';
import { toast } from 'react-toastify';
import { useAuth } from '../hooks/useAuth';
import { getApiErrorMessage } from '../utils/getApiErrorMessage';

export const EntryContext = createContext({});

export function EntryProvider({ children }) {
  const [entries, setEntries] = useState([]);
  const [countEntries, setCountEntries] = useState(0);
  const [entriesLoader, setEntriesLoader] = useState(false);
  const [receivables, setReceivables] = useState([]);
  const [receivablesLoader, setReceivablesLoader] = useState(false);

  const { user } = useAuth();

  async function updateEntriesFitbank() {
    if (user.taxNumber !== '12345678900') {
      await apiV1
        .post(`/entrys/fitbank/update`)
        .then((response) => { })
        .catch((err) => { });
    }
  }

  async function fetchEntries(
    page = '',
    initialDate = '',
    finalDate = '',
    type = ''
  ) {
    setEntriesLoader(true);
    await updateEntriesFitbank();

    setEntries([]);

    await apiV1
      .get(
        `/entrys?page=${page}&initialDate=${initialDate}&finalDate=${finalDate}&type=${type}`
      )
      .then(async (response) => {
        setEntries(response.data.entrys);
        setCountEntries(response.data.count);
        setEntriesLoader(false);
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Não foi possível carregar os Extratos'));
        setEntriesLoader(false);
      });
  }

  async function fetchReceivables(initialDate, finalDate, page) {
    try {
      setReceivablesLoader(true);
      const response = await apiV1.get('/receivable/list?initialDate=' + initialDate + '&finalDate=' + finalDate + '&page=' + page);
      setReceivables(response.data.receivables);
      setReceivablesLoader(false);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setReceivablesLoader(false);
    }
  }

  async function verifyEstablishment() {
    try {
      const { data } = await apiV1.get('/establishment/verify');
      return data;
    } catch (err) {
      console.log("err ", err);
    }
  }
  async function exportEntries(format, initialDate = '', finalDate = '', type = '') {
    try {
      const response = await apiV1.get(
        `/entrys/export?format=${format}&initialDate=${initialDate}&finalDate=${finalDate}&type=${type}`,
        { responseType: 'blob' }
      );

      const contentType = response.headers['content-type'];
      const extension = format === 'pdf' ? 'pdf' : 'csv';
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `extrato.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Erro ao exportar extrato. Tente novamente.'));
      return false;
    }
  }

  return (
    <EntryContext.Provider
      value={{
        entries,
        entriesLoader,
        updateEntriesFitbank,
        fetchEntries,
        countEntries,
        setCountEntries,
        fetchReceivables,
        receivables,
        receivablesLoader,
        verifyEstablishment,
        exportEntries,
      }}
    >
      {children}
    </EntryContext.Provider>
  );
}
